import Vue from "vue";
import vueResource from "vue-resource";
import { Loading } from 'element-ui';
Vue.use(vueResource)

const baseUrl = process.env.API_ROOT;
const API_UP = process.env.API_UP;
Vue.http.options.emulateJSON = true;
Vue.http.interceptors.push((request, next) => {
	// var TOKEN = sessionStorage.getItem('token') || '';
	// request.headers.set('token', TOKEN);
	//配置请求头
	next((response) => {
		if (!response) {
			//do something when response
		}
		return response;
	});
});

export function post(url, params,load=true) {
	// console.log(load)
	return new Promise((resolve, reject) => {
		var TokenId = localStorage.getItem('TokenId') || '';
		var raf = localStorage.getItem('raf') || '';
		var lang  = localStorage.getItem('lang') || '';
		var admin_type  = localStorage.getItem('admin_type');
		
		let d = Math.round(new Date(2022,0,1,0,0,0).getTime()/1000);
		let t = Math.round(Date.UTC(2022,0,1,0,0,0)/1000);
		var cha_time=t-d;

		params['cha_time']=cha_time;
	    var y,m,dd,h,i,s;  
	    var date = new Date();
	    y = date.getFullYear();    //年
	    m = date.getMonth();    // 月
	    dd = date.getDate();    //日
	    h = date.getHours();    //时
	    i = date.getMinutes();    //分
	    s = date.getSeconds();   //秒
		let tt = Math.round(Date.UTC(y,m,dd,h,i,s)/1000);
		params['utc_time']=tt;

		params['TokenId']=TokenId;
		params['raf']=raf;
		params['language']=lang=='cn'?'cn':'us';
		if(!params.admin_type){
			params['admin_type']=admin_type=='cn'?'cn':'us';  //国家
		}
		var loadingInstance=false;
		if (load) {
			loadingInstance = Loading.service({fullscreen:true});
		}
		Vue.http.post(baseUrl + url, params ).then(res => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else if(res.body.status == 401){
					localStorage.removeItem('TokenId');
					this.$router.push('/login');
				} else {
					this.$message({
						message: res.body.message,
						type:'error',
						showClose:true,
						duration:0,
					});
				}
			} else if(res.status == 0) {
				localStorage.removeItem('TokenId');
				this.$router.push('/login');
			} else {
				this.$message.error('请检查网络');
			}
			if (load&&loadingInstance) {
				loadingInstance.close();
			}
		}).catch((err) => {
			if (load&&loadingInstance) {
		        loadingInstance.close();
			}
			reject(err);
		});
	});
}
export function post_API_UP(url, params,load=true) {
	// console.log(load)
	return new Promise((resolve, reject) => {
		var TokenId = localStorage.getItem('TokenId') || '';
		var raf = localStorage.getItem('raf') || '';
		var lang  = localStorage.getItem('lang') || '';
		var admin_type  = localStorage.getItem('admin_type');
		params['TokenId']=TokenId;
		params['raf']=raf;
		params['language']=lang=='cn'?'cn':'us';
		if(!params.admin_type){
			params['admin_type']=admin_type=='cn'?'cn':'us';  //国家
		}
		var loadingInstance=false;
		if (load) {
			loadingInstance = Loading.service({fullscreen:true});
		}
		Vue.http.post(API_UP + url, params ).then(res => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else if(res.body.status == 401){
					localStorage.removeItem('TokenId');
					this.$router.push('/login');
				} else {
					this.$message({
						message: res.body.message,
						type:'error',
						showClose:true,
						duration:0,
					});
				}
			} else if(res.status == 0) {
				localStorage.removeItem('TokenId');
				this.$router.push('/login');
			} else {
				this.$message.error('请检查网络');
			}
			if (load&&loadingInstance) {
				loadingInstance.close();
			}
		}).catch((err) => {
			if (load&&loadingInstance) {
		        loadingInstance.close();
			}
			reject(err);
		});
	});
}
export function get(url,params) {
	return new Promise((resolve, reject) => {
		var TokenId = localStorage.getItem('TokenId') || '';
		var raf = localStorage.getItem('raf') || '';
		var lang  = localStorage.getItem('lang') || '';
		var admin_type  = localStorage.getItem('admin_type') || '';
		params['TokenId']=TokenId;
		params['raf']=raf;
		params['language']=lang=='en'?'us':'cn';
		if(!params.admin_type){
			params['admin_type']=admin_type=='us'?'us':'cn';  //国家
		}
		Vue.http.get(baseUrl + url,params ) .then((res) => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else if(res.body.status == 401){
					localStorage.removeItem('TokenId');
					this.$router.push('/');
				} else {
					this.$message.error({
						showClose:true,
						duration:0,
						message: err.body.message,
					});
				}
			} else {
				this.$message.error('请检查网络');
			}
		}) .catch((err) => {
			if (loading) {
		        loading.close();
			}
			this.$message.error({
				showClose:true,
				duration:0,
				message: err.body.message,
			});
			reject(err);
		});
	});
}



//////////////////
// WEBPACK FOOTER
// ./store/vue_resource.js
// module id = null
// module chunks = 